import { render, staticRenderFns } from "./SettingTranslationInputs.vue?vue&type=template&id=7887c36a&"
import script from "./SettingTranslationInputs.vue?vue&type=script&lang=ts&"
export * from "./SettingTranslationInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports